import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Link, useNavigate} from "react-router-dom";
import { ReactComponent as SearchIco } from "../../assets/images/icons/magnifying-glass-solid.svg";
import { ReactComponent as GuidesIco } from "../../assets/images/icons/guides.svg";
import { ReactComponent as ConnectIco } from "../../assets/images/icons/connect.svg";
import { ReactComponent as VideoIco } from "../../assets/images/icons/video.svg";
import { ReactComponent as SupportIco } from "../../assets/images/icons/support.svg";
import Faq from "../home/Faq";
import Paths from "../../constants/Paths";

const Support = () => {
    return (
        <>
            <PageBanner title="Support" slug="support"/>
            <section className="generic-container py-14">
                <div className="search-bar mb-8">
                    <input type="text" placeholder="Enter your query..." className="search-input border"/>
                    <button className="small-button dark-variant">
                        Search
                    </button>
                </div>
                <div className="icon-boxes gap-4 mb-8">
                    <Link to={Paths.SUPPORT_VIDEO} className="icon-box text-center border">
                        <VideoIco className="icon mb-2 text-lt-blue" style={{ maxWidth: '50px', width: '100%', height: 'auto' }}/>
                        <p className="font-bold">Video Tips For Beginners</p>
                    </Link>
                    <Link to={Paths.SUPPORT_AI} className="icon-box text-center border">
                        <ConnectIco className="icon mb-2 text-lt-blue" style={{ maxWidth: '50px', width: '100%', height: 'auto' }}/>
                        <p className="font-bold">AI Assistant Guides</p>
                    </Link>
                    <Link to={Paths.SUPPORT_ONLINE} className="icon-box text-center border">
                        <GuidesIco className="icon mb-2 text-lt-blue" style={{ maxWidth: '50px', width: '100%', height: 'auto' }}/>
                        <p className="font-bold">Online Support Guides</p>
                    </Link>
                    <Link to={Paths.SUPPORT_DISCORD} className="icon-box text-center border">
                        <SupportIco className="icon mb-2 text-lt-blue" style={{ maxWidth: '50px', width: '100%', height: 'auto' }}/>
                        <p className="font-bold">Discord Support Forum</p>
                    </Link>
                </div>
                <div className="content-boxes grid grid-cols-2 gap-4 mb-8">
                    <div className="content-box p-4 border">
                        <h3 className="title mb-2 text-2xl font-bold text-lt-blue">FAQ</h3>
                        <Faq page="support"/>
                    </div>
                    <div className="content-box p-4 border">
                        <h3 className="title mb-2 text-2xl font-bold text-lt-blue">Getting Started</h3>
                        <p className="text mb-4 font-bold" style={{ marginTop: '22px' }}>How to Start Trading with Us - Step by Step?</p>

                        <ol>
                            <li>
                                <p className="font-bold">1. Register Your Account.</p>
                                <ul className="list-disc ml-8">
                                    <li>Visit our website and click "Sign Up".</li>
                                    <li>Enter your email address, create a password, and confirm your registration by
                                        clicking the link in the verification email.
                                    </li>
                                </ul>
                            </li>

                            <li className="mt-4">
                                <p className="font-bold">2. Activate Access to the AI Assistant.</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Log into your account.</li>
                                <li>Go to the Subscriptions section and choose a plan to access the AI Assistant.
                                    Complete the payment, and your access will be activated automatically.
                                </li>
                            </ul>

                            <li className="mt-4">
                                <p className="font-bold">3. Configure the AI Assistant.</p>
                                <p className="ml-4">Navigate to the AI Assistant tab and adjust your settings:</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Select your preferred technical indicators (e.g., EMA, linear regression).</li>
                                <li>Set Sensitivity and signal duration.</li>
                            </ul>

                            <li className="mt-4">
                                <p className="font-bold">4. Analyze the Market and Identify Trading Opportunities.</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Use the magic technical analysis button, which automatically detects key levels and
                                    trends.
                                </li>
                                <li>Review the generated signals and select the ones that best fit your strategy.</li>
                            </ul>

                            <li className="mt-4">
                                <p className="font-bold">5. Receive Notifications for the Best Signals.</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Enable notifications to never miss a key market opportunity.</li>
                                <li>Get instant alerts via phone or email when crucial trading moments occur.</li>
                            </ul>

                            <li className="mt-4">
                                <p className="font-bold">6. Execute Trades and Manage Positions.</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Make informed decisions based on AI-generated signals.</li>
                                <li>Use chart drawing tools to better plan your trades and manage your positions.</li>
                            </ul>

                            <li className="mt-4">
                                <p className="font-bold">7.	Monitor Performance and Optimize Your Strategy.</p>
                            </li>
                            <ul className="list-disc ml-8">
                                <li>Regularly review your results and fine-tune the AI Assistant settings.</li>
                                <li>Experiment with different indicator configurations to optimize your trading strategy.</li>
                            </ul>
                        </ol>


                        {/* <button className="small-button dark-variant">View all</button> */}
                    </div>
                </div>
                <div className="text-center mt-14">
                    <Link to="mailto:support@lockedtrade.com" className="big-button dark-variant">Contact Support</Link>
                </div>
            </section>
        </>
    );
};

export default Support;